import { Link } from "react-router-dom";
import { siteInfo, stats } from "@/mocks/site";

const Hero = () => (
  <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center">
    <div className="absolute inset-0 w-full h-full">
      <img
        src="https://readdy.ai/api/search-image?query=Cinematic%20abstract%20editorial%20background%20about%20internet%20gossip%20and%20controversy%2C%20stylized%20dark%20archive%20room%20with%20rows%20of%20glowing%20folders%20and%20floating%20message%20bubbles%20under%20a%20single%20spotlight%20beam%2C%20deep%20warm%20brown%20and%20terracotta%20tones%20with%20subtle%20teal%20accents%2C%20dramatic%20moody%20lighting%20with%20high%20contrast%20for%20text%20overlay%2C%20no%20text%20or%20letters&width=1600&height=1000&seq=gua-hero-main&orientation=landscape"
        alt="塌房档案局 档案室主题背景插画"
        className="w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/80 via-foreground-950/70 to-foreground-950/85" />
    </div>

    <div className="relative z-10 w-full px-4 md:px-8 py-24 md:py-28">
      <div className="max-w-3xl mx-auto text-center animate-rise">
        <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full text-xs md:text-sm bg-background-50/15 text-background-50 border border-background-50/25">
          <i className="ri-database-2-line" />
          已归档 128 起塌房事件
        </span>

        <h1 className="mt-6 font-heading font-black text-3xl md:text-5xl lg:text-6xl leading-tight text-background-50">
          {siteInfo.name}
          <span className="block mt-3 text-xl md:text-3xl font-bold text-primary-200">
            {siteInfo.slogan}
          </span>
        </h1>

        <p className="mt-6 text-sm md:text-lg leading-relaxed text-background-100/90 max-w-2xl mx-auto">
          起底网红塌房背后的旧料与黑历史，汇总过往言论、历史爆料与黑料合集，
          把碎片信息串成清晰的时间线，一次看完旧账翻出的全过程。
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/cases"
            className="w-full sm:w-auto px-7 py-3 rounded-md text-sm md:text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            进入塌房合集
          </Link>
          <Link
            to="/about#submit"
            className="w-full sm:w-auto px-7 py-3 rounded-md text-sm md:text-base font-medium bg-background-50/10 text-background-50 border border-background-50/30 hover:bg-background-50/20 transition-colors whitespace-nowrap"
          >
            我有线索要爆料
          </Link>
        </div>
      </div>

      <div className="mt-14 md:mt-20 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5 max-w-5xl mx-auto">
        {stats.map((item) => (
          <div
            key={item.label}
            className="rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm px-4 py-4 md:px-5 md:py-6 text-center"
          >
            <p className="font-heading font-black text-2xl md:text-4xl text-background-50">
              {item.value}
              <span className="text-sm md:text-lg font-bold text-primary-200 ml-1">
                {item.suffix}
              </span>
            </p>
            <p className="mt-1.5 text-xs md:text-sm text-background-200">{item.label}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Hero;